module.exports = __webpack_public_path__ + "img/greenit.d60a1b3c.png";